export enum Database {
  MONGO_DB = 'mongodb',
  INFLUX_DB = 'influxdb'
}